<template>
  <div class="lmap-container map-container">
    <l-map
      ref="map"
      class="fmap"
      :zoom="zoom"
      :center="center"
      :bounds="bounds"
      :useGlobalLeaflet="false"
      :options="{ attributionControl: false }"
       @ready="onMapReady"
    >
      <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <l-marker v-for="marker in locations" :key="marker.id" :lat-lng="[marker.lat, marker.lng]" :options="{ opacity: markerOpacity }" />
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LGeoJson } from "@vue-leaflet/vue-leaflet";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import FreeDraw from "leaflet-freedraw";

export default {
  name: 'LeafletMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LGeoJson
  },
  props: {
    locations: [],
    polylines: [],
    heatdata: []
  },
  data() {
    return {
      zoom: 10,
      center: [0, 0],
      markers: [],
      bounds: null,
      mapInstance: null,
      markerOpacity: 1,
      freeDrawInstance: null, 
      boundaryMarkers: [],
      lastPolygonLayer: null
    };
  },
  methods: {
    updateMapBounds() {
      if (this.locations.length > 0) {
        const latLngs = this.locations.map(marker => [marker.lat, marker.lng]);
        this.bounds = latLngs;
        this.$nextTick(() => {
          this.mapInstance = this.$refs.map.mapObject;
          if(this.mapInstance) {
            this.mapInstance.fitBounds(this.bounds, { padding: [75, 75] });
          }
        });
      }
    },
    onMapReady(mapObject) {
      this.mapInstance = mapObject;
      this.mapInstance.fitBounds(this.locations.map(marker => [marker.lat, marker.lng]));
      this.freeDrawInstance = new FreeDraw();
      this.mapInstance.addLayer(this.freeDrawInstance);

      //let lastPolygonLayer = null;

        this.freeDrawInstance.on('markers', (event) => {
          //console.log('FREE DRAWN EVENT', event);
          const coordinates = event.latLngs[0];
          //console.log('Drawn coordinates:', coordinates);
          this.handleBoundaryMarkers(coordinates); 

          if (this.lastPolygonLayer) {
            this.mapInstance.removeLayer(this.lastPolygonLayer);
          }

          // start manual polygon fill method
          //event.latLngs.forEach((polygon) => {
            //const layer = L.polygon(polygon, {
              //fill: true,
              //fillColor: '#FF0000',
              //fillOpacity: 0.5,
            //});
            //this.mapInstance.addLayer(layer);
          //});

          const combinedPolygon = L.polygon(coordinates, {
            fill: true,
            fillColor: '#FF0000',
            fillOpacity: 0.5,
          });
          this.mapInstance.addLayer(combinedPolygon);
          this.lastPolygonLayer = combinedPolygon;
          
        });

        // start listeners
        this.mapInstance.on('zoomend', () => {
          console.log('Map zoom ended. Current map boundaries:', this.mapInstance.getBounds());
          alert('Map zoom ended. Current map boundaries: ' + JSON.stringify(this.mapInstance.getBounds()));
        });

        this.mapInstance.on('dragend', () => {
          console.log('Map drag ended. Current map boundaries:', this.mapInstance.getBounds());
          alert('Map drag ended. Current map boundaries: ' + JSON.stringify(this.mapInstance.getBounds()));
        });
        // end listeners

    },
    clearLastPolygon() {
      if (this.mapInstance && this.lastPolygonLayer) {
        this.mapInstance.removeLayer(this.lastPolygonLayer);
        this.lastPolygonLayer = null;
        console.log('Last polygon cleared.');
      }
      // Clear FreeDraw markers
      if (this.freeDrawInstance) {
        this.freeDrawInstance.clear();
        console.log('FreeDraw markers cleared.');
      }
      // Reset boundary markers
      this.boundaryMarkers = [];
      console.log('Boundary markers reset.');
    },
    handleBoundaryMarkers(coordinates) {
      const simplifiedCoordinates = coordinates.map(coord => ({
        lat: coord.lat,
        lng: coord.lng
      }));
      this.boundaryMarkers = simplifiedCoordinates;
      console.log('Boundary markers updated:'+JSON.stringify(simplifiedCoordinates));
      console.log('Boundary markers:', this.boundaryMarkers);
      console.log('test process submit to modal with coordinates:', JSON.stringify(simplifiedCoordinates));
      this.$emit('openModal', {view: 'RetrieveMapBoundaries', dt: JSON.stringify(simplifiedCoordinates)});
    }
  },
  watch: {
    locations: {
      handler: 'updateMapBounds',
      deep: true
    }
  },
  mounted() {
    
  }
};
</script>